import { Component, OnInit } from '@angular/core';
import {NgbCarouselConfig} from '@ng-bootstrap/ng-bootstrap';
import { NgxCarousel } from 'ngx-carousel';

@Component({
  selector: 'app-customers-slider',
  templateUrl: './customers-slider.component.html',
  styleUrls: ['./customers-slider.component.css'],
  //providers: [NgbCarouselConfig] // add NgbCarouselConfig to the component providers
})
export class CustomersSliderComponent implements OnInit {

 constructor(config: NgbCarouselConfig) {
    // customize default values of carousels used by this component tree
    config.interval = 10000;
    config.wrap = false;
    config.keyboard = false;
  }

  public carouselTileItems: Array<any>;
  public carouselTile: NgxCarousel;
 
  ngOnInit(){
    this.carouselTileItems = [
      {'title':"", 'value':"I've never left a review, but my sheets and clothing have never been more clean (and I weirdly love doing laundry). My sheets were bright and days later, they still smell like they were just removed from the dyer. I could not recommend Laundry.bz more. ", "name":"Laura P. Elkins Park Pa:"},
      {'title':"", 'value':"Slice been using them for years and have never had any issues. Clothes always clean, they're always on time, the price is consistant, delivery kind.", "name":"J.M. Brooklyn NY:"},
      {'title':"", 'value':"Two weeks ago I accidentally put N air dry cashmere sweater in without marking it. They returned it to me in a separate bag marked \"air dry\" rather than sending me back a ruined sweater.", "name":"J.M. Brooklyn NY:"},
      {'title':"", 'value':"I got an e-mail bill today and it said: note we found $44 in a pocket and them they didn\'t charge me for the laundry because it too was $44. They FOUND money in my pocket, told me about it, and made sure it was returned to me.","name":"J.M. Brooklyn NY:"},
      {'title':"", 'value':"I've always been a fan, but I don't think I'd even consider using another company average this month. Really above and beyond and good people Give them your business.", "name":"J.M. Brooklyn NY:"},
      {'title':"", 'value':"Had a really positive experience, service is polite and on time. Clothes were clean and undamaged. Really great service, and you can pay online, which I like.", "name":"JM:"},
      {'title':"", 'value':"I just used this place for the first time.i haven't examined every single piece of clothing, but so far it seems like the followed my instructions carefully on which pieces could not go into the dryer, or be washed in warm water, which was my biggest worry with having somebody else do my laundry. My sheets feel super soft, too.  Not sure if it's an ongoing thing, but I got 25% off first time service which was a nice bonus.", "name":"M Y. Austin Texas:"},
      {'title':"", 'value':"I've used them just about weekly since moving to the neighbourhood last fall. They are really an excellent service I've never had an issue with pick up, drop off,misplaced or ruined items. And I've sent everything thief way at some point or another. They are always very pleasant. In fact, they've helped me out a couple of times when at the last minute I had to work late and wasn't going to be home during my drop-off window. They've dropped it off later for me with very little notice.i appreciate that. And on top of that, they always follow my laundry care requests with. O problem", "name":"Grace G Bedford Stuyvesant Brooklyn:"},
      {'title':"", 'value':"I've been using Laundry.bz consistently (almost weekly) since I moved into the neighbourhood a few more Nigerian ago and can vouch for them being a truly excellent service.  They have not once ruined lost or misplaced anything I've owned. (Which is a rRe exception in  Brooklyn!) they follow my laundry and care requests to a t. Not only that, in times when I needed rush jobs done or special care, they've gone the extra mile for me to make sure things get done. I really appreciate their service and can't recommend them highly enough for other busy folks who rely on a pick up and drop off service", "name":"Ron G. Brooklyn NY:"}];
 
    this.carouselTile = {
      grid: {xs: 1, sm: 2, md: 3, lg: 3, all: 0},
      slide: 2,
      speed: 400,
      animation: 'lazy',
      point: {
        visible: false
      },
      load: 2,
      touch: true,
      easing: 'ease'
    }
  }
  
  carouselTileLoad(event){
	  
  }
 
  public  (evt: any) {
 
    const len = this.carouselTileItems.length
    if (len <= 30) {
      for (let i = len; i < len + 10; i++) {
        this.carouselTileItems.push(i);
      }
    }

}
}





// WEBPACK FOOTER //
// D:/xampp/htdocs/laundry-pickup/laundry-pickup-website/src/app/customers-slider/customers-slider.component.ts